import React from "react";
import { Route, Routes } from "react-router-dom";
import Footer from "./constants/footer";
import Header from "./constants/header";
import HomePage from "./pages/home";
import AboutPage from "./pages/about";
import EventsPage from "./pages/events";
import ArtistsPage from "./pages/artists";
import GalleryLanding from "./pages/gallery-landing";
import GalleryPage from "./pages/gallery-page";
import ContactPage from "./pages/contact";
import ArtistInfo from "./pages/artistinfo";
import BlogWrapper from "./components/blog-wrapper";
import BlogPage from "./pages/blog";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* Artists Routes */}
        <Route path="/artists" element={<ArtistsPage />} />
        <Route path="/artists/:web" element={<ArtistInfo />} />

        {/* Gallery Routes */}
        <Route path="/gallery" element={<GalleryLanding />} />
        <Route path="/gallery/*" element={<GalleryPage />} />
        <Route path="/blog/:slug" element={<BlogWrapper />} />
        <Route path="/blog" element={<BlogPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
